// @generated
// This file is automatically generated by Kanel. Do not modify manually.

import { z } from 'zod';

/** Represents the enum public.organization_audit_operation_type */
enum OrganizationAuditOperationType {
  INSERT = 'INSERT',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
};

export default OrganizationAuditOperationType;

/** Zod schema for organization_audit_operation_type */
export const organizationAuditOperationType = z.enum([
  'INSERT',
  'UPDATE',
  'DELETE',
]);
